/**
 * Verification pill — shows the current review state of an institution/major/roadmap record.
 * Status: verified | awaiting | needs_review | draft | archived
 */
const STATUS_STYLE = {
  verified:     { bg: "bg-ivy/10",   text: "text-ivy",   label: "Verified" },
  awaiting:     { bg: "bg-brass/15",  text: "text-brass",  label: "Awaiting Verification" },
  needs_review: { bg: "bg-crimson/10",text: "text-crimson",label: "Needs Review" },
  draft:        { bg: "bg-stone/20",  text: "text-stone",  label: "Draft" },
  archived:     { bg: "bg-stone/10",  text: "text-stone",  label: "Archived" },
};

export default function VerificationLabel({ status = "awaiting", className = "", showBanner = false, lastReviewed = null }) {
  const s = STATUS_STYLE[status] || STATUS_STYLE.awaiting;
  const pill = (
    <span
      className={`inline-flex items-center gap-1.5 ${s.bg} ${s.text} border border-current/20 px-2.5 py-1 text-[9px] uppercase tracking-[0.22em] font-semibold ${className}`}
      data-testid={`verification-${status}`}
    >
      <span className="h-1.5 w-1.5 bg-current" />
      {s.label}
      {lastReviewed && <span className="text-current/70 normal-case tracking-normal">· Last reviewed: {lastReviewed}</span>}
    </span>
  );
  if (!showBanner || status === "verified") return pill;
  return (
    <div className="border-l-2 border-brass bg-brass/5 px-4 py-3 text-sm text-ink" data-testid="verification-banner">
      <div className="flex items-baseline gap-3 flex-wrap">{pill}</div>
      <p className="mt-2 text-[13px] leading-relaxed text-ink-soft">
        <strong>Verification Pending</strong> — confirm this requirement with the institution before making an academic decision.
      </p>
    </div>
  );
}
